import { createFileRoute, redirect } from '@tanstack/react-router'
import { CustomerCreateView } from '@/features/customers/customers'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/customers/new')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'customer.create')) {
      throw redirect({ to: '/customers' })
    }
  },
  component: CustomerCreateView,
})
